import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as Aos from "aos";
import {DataService} from "../shared/data/data.service";
import {OwlOptions} from "ngx-owl-carousel-o";
import {doctorSliderOne, partnersSlider, specialitiesSliderOne} from 'src/app/shared/models/models';
import {PortalService} from "../core/web/portal-service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent  implements OnInit, AfterViewInit{
  public progress = 0;
  public strokeValue = 0;
  public form!: FormGroup;


  public specialitiesSliderOne: specialitiesSliderOne[];
  public doctorSliderOne: doctorSliderOne[];
  public partnersSlider: partnersSlider[] = [];
  protected myDateValue!: Date ;
  protected doctorsList: Array<any> | undefined;


  @ViewChild('cursorOuter', { static: false }) cursorOuter!: ElementRef;
  @ViewChild('cursorInner', { static: false }) cursorInner!: ElementRef;

  private cursorInnerElement!: HTMLElement;
  private cursorOuterElement!: HTMLElement;

  constructor(
      private data: DataService,
      private elementRef: ElementRef,
      private portalService: PortalService,
      private formBuilder: FormBuilder,
      private router: Router,

  ) {
    this.specialitiesSliderOne = this.data.specialitiesSliderOne;
    this.doctorSliderOne = this.data.doctorSliderOne;
    this.partnersSlider = this.data.partnersSlider;
  }




  ngOnInit(): void {
    this.initForm();
    Aos.init({
      duration: 1500,
      once: true,
    });
    this.myDateValue = new Date();
    this.calculateScrollPercentage();
    this.onLoadDoctors();
  }

  protected initForm(): void {
    this.form = this.formBuilder.group({
      term:[null],
      emplacement:[null],
      page: {page: 0, size: 12},
    });
  }

  onLoadDoctors(): void {
    this.portalService.getDoctors(this.form.value).subscribe(response => this.doctorsList = response.content);
  }


  ngAfterViewInit(): void {
    this.cursorInnerElement = this.cursorInner.nativeElement;
    this.cursorOuterElement = this.cursorOuter.nativeElement;
    this.initCursor();
  }

  private initCursor(): void {
    const body = document.body;

    body.addEventListener('mousemove', (event: MouseEvent) => {
      this.cursorOuterElement.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
      this.cursorInnerElement.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
    });

    const cursorPointerElements = this.elementRef.nativeElement.querySelectorAll('a, .cursor-pointer');

    cursorPointerElements.forEach((element: HTMLElement) => {
      element.addEventListener('mouseenter', () => {
        this.cursorInnerElement.classList.add('cursor-hover');
        this.cursorOuterElement.classList.add('cursor-hover');
      });

      element.addEventListener('mouseleave', () => {
        if (!(element.tagName === 'A' && element.closest('.cursor-pointer'))) {
          this.cursorInnerElement.classList.remove('cursor-hover');
          this.cursorOuterElement.classList.remove('cursor-hover');
        }
      });
    });

    this.cursorInnerElement.style.visibility = 'visible';
    this.cursorOuterElement.style.visibility = 'visible';
  }

  // function to calculate the scroll progress
  private calculateScrollPercentage(): void {
    window.addEventListener('scroll', () => {
      const body = document.body,
        html = document.documentElement;
      //gets the total height of page till scroll
      const totalheight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      // calculates the total stroke value
      this.progress = totalheight;
      const currentDistance = window.scrollY / (totalheight / 3000);
      // calculates the current stroke value
      this.strokeValue = totalheight - currentDistance / 8;
      // condition to hide scroll progress if page in top
      if (window.scrollY == 0) {
        this.strokeValue = totalheight;
      }
      // condition to make scroll progress to 100 if page in bottom
      if (window.innerHeight + window.scrollY >= totalheight) {
        this.strokeValue = 0;
      }
    });
  }
  public scrollToTop(): void {
    window.scrollTo(0, 0);
  }





  public partnersSliderOption: OwlOptions = {
    margin: 24,
    nav: true,
    loop: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: {
      0: {
        items: 1
      },

      550: {
        items: 1
      },
      700: {
        items: 4
      },
      1000: {
        items: 6
      }
    }
  };


  onSearch() {
    this.router.navigate(['portail/search'], {queryParams: {term: this.form.value.term, emplacement: this.form.value.emplacement}});
  }

}
